module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAYAAACqaXHeAAAACXBIWXMAAAsSAAALEgHS3X78AAAAjElEQVR42u3YAQ2AQAwDwD1BzzSAsgdlSBtCepVwyZama2YqOUeFBwAAANlZ3f0kA5xVtZ0AAAAAAAAAACC1CN3RVdgg4gcAAAAAAAAAAFKboFHUKOoHAAAAAAAAAMFFyCjqBAAAAAAAAAAAkUWou6/0Kvw5AQAAAAAAAABAahF6o6uwTdAPAAAAQHB+jmQSGC/rBqYAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// C:/Aero/Angular/memory-map/src/assets/images/burger_dark_grey.png
// module id = ../../../../../src/assets/images/burger_dark_grey.png
// module chunks = styles